"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRaceForRewardsPlayers = void 0;
const react_1 = require("react");
const DISPLAY_MEDIA_INCREMENT = 3;
const useRaceForRewardsPlayers = (media) => {
    const [displayMedia, setDisplayMedia] = (0, react_1.useState)(DISPLAY_MEDIA_INCREMENT);
    const onShowMoreClick = () => {
        if (displayMedia < media.length) {
            setDisplayMedia(displayMedia + DISPLAY_MEDIA_INCREMENT);
        }
    };
    const displayedMedia = media.slice(0, displayMedia);
    const isAutoplay = (index) => index === 0;
    const displayShowMore = displayedMedia < media;
    return {
        displayedMedia,
        displayShowMore,
        onShowMoreClick,
        isAutoplay,
    };
};
exports.useRaceForRewardsPlayers = useRaceForRewardsPlayers;
